module.exports = __webpack_public_path__ + "GL_logo_white.e23c8d84334460736320fc9be0bea46a.png";